import React from 'react';
import '../styles/roomDetail.css';

const RoomHero = ({ title, subtitle, image, language }) => {
  return (
    <section className="room-hero" style={{ backgroundImage: `url(${image})` }}>
      <div className="room-hero-overlay"></div>
      <div className="container position-relative">
        <div className="room-hero-content text-center text-white">
          <h1 className="room-hero-title">{title[language]}</h1>
          {subtitle && <p className="room-hero-subtitle">{subtitle[language]}</p>}
        </div>
      </div>
    </section>
  );
};

export default RoomHero;
